
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const [{createUI, installThemeToggle, installHashImportBanner}, {createGameUI, loadGame, makeClient, prepareGameFile}] = await Promise.all([import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  return module;
}), import("./lib/bgio.js").then((module) => {
  if (!("createGameUI" in module)) throw new SyntaxError(`export 'createGameUI' not found`);
  if (!("loadGame" in module)) throw new SyntaxError(`export 'loadGame' not found`);
  if (!("makeClient" in module)) throw new SyntaxError(`export 'makeClient' not found`);
  if (!("prepareGameFile" in module)) throw new SyntaxError(`export 'prepareGameFile' not found`);
  return module;
})]);
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint } = createUI({ html });
const { gameBoard, mountEditor, mountGameSection } = createGameUI({ html });
const starter = prepareGameFile(1);
return {createUI,installThemeToggle,installHashImportBanner,createGameUI,loadGame,makeClient,prepareGameFile,codeEditor,ok,err,hint,gameBoard,mountEditor,mountGameSection,starter};
},
    inputs: ["html","display"],
    outputs: ["createUI","installThemeToggle","installHashImportBanner","createGameUI","loadGame","makeClient","prepareGameFile","codeEditor","ok","err","hint","gameBoard","mountEditor","mountGameSection","starter"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-3`),
    expanded: [],
    variables: []
  },
  {
    id: 3,
    body: (codeEditor,starter,html,makeClient,loadGame,err,ok,gameBoard,mountEditor,mountGameSection) => {
const editor = codeEditor("bgio:game", { value: starter, label: "Deine Datei: TicTacToe.js" });
const boardSlot = html`<div></div>`;
const feedbackSlot = html`<div></div>`;

function check(code) {
  try {
    const client = makeClient(loadGame(code));
    const st = client.getState();
    const cells = st && st.G && st.G.cells;
    const setupOk = Array.isArray(cells) && cells.length === 9 && cells.every(c => c === null);
    if (!setupOk)
      return err(html`<code>setup</code> sollte <code>{ cells: [...] }</code> mit genau 9-mal <code>null</code> zurückgeben.`);
    client.moves.clickCell(4);
    if (client.getState().G.cells[4] !== "0")
      return err(html`Nach <code>clickCell(4)</code> von Spieler 0 sollte <code>cells[4]</code> den Wert <code>"0"</code> haben — trag <code>move.playerID</code> an der Stelle <code>cellIndex</code> ein.`);
    return ok(html`🎉 Geschafft! <code>setup</code> und <code>clickCell</code> funktionieren.`);
  } catch (e) {
    return err(html`Dein Code lässt sich nicht ausführen: ${e.message}`);
  }
}

function rerun() {
  const code = editor.value;
  boardSlot.replaceChildren(gameBoard(code, {
    showDebug: true,
    showState: true,
    hint: "Alle Markierungen sind ✕ (Spieler 0), bis du im Debug Panel auf endTurn klickst — automatisches Wechseln kommt in Kapitel 2."
  }));
  feedbackSlot.replaceChildren(check(code));
}
mountEditor({ editor });
const section = mountGameSection({
  nodes: [boardSlot, feedbackSlot],
  onRun: () => { const b = editor.querySelector(".run-button"); if (b) b.click(); }
});
editor.addEventListener("input", () => { rerun(); section.expand(); });
rerun();
return {editor,boardSlot,feedbackSlot,check,rerun,section};
},
    inputs: ["codeEditor","starter","html","makeClient","loadGame","err","ok","gameBoard","mountEditor","mountGameSection"],
    outputs: ["editor","boardSlot","feedbackSlot","check","rerun","section"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
